import { SvgIcon } from '@material-ui/core'

export default function StudioIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 22" fill="none" {...props}>
            <path d="M13.2448 9.97998H10.7578V10.844H13.2448V9.97998Z" fill="url(#paint0_linear_1280_36307)" />
            <path
                d="M1.4999 14.291L0.149902 18.341H23.8499L22.4999 14.291H1.4999ZM3.6449 15.803L3.2159 17.393C3.1889 17.492 3.0989 17.558 2.9999 17.558C2.9819 17.558 2.9609 17.558 2.9399 17.549C2.8199 17.516 2.7479 17.393 2.7809 17.273L3.2099 15.683C3.2429 15.563 3.3659 15.491 3.4859 15.524C3.6059 15.557 3.6779 15.68 3.6449 15.8V15.803ZM6.2189 17.375C6.1979 17.483 6.1049 17.561 5.9969 17.561C5.9849 17.561 5.9699 17.561 5.9579 17.558C5.8349 17.537 5.7539 17.42 5.7749 17.297L6.0599 15.707C6.0809 15.584 6.1979 15.503 6.3209 15.524C6.4439 15.545 6.5249 15.662 6.5039 15.785L6.2189 17.375ZM9.2219 17.354C9.2099 17.471 9.1139 17.558 8.9969 17.558C8.9909 17.558 8.9849 17.558 8.9759 17.558C8.8529 17.546 8.7599 17.438 8.7719 17.315L8.9159 15.725C8.9279 15.602 9.0329 15.509 9.1589 15.521C9.2819 15.533 9.3749 15.641 9.3629 15.764L9.2189 17.354H9.2219ZM12.2219 17.333C12.2219 17.456 12.1199 17.558 11.9969 17.558C11.8739 17.558 11.7719 17.456 11.7719 17.333V15.743C11.7719 15.62 11.8739 15.518 11.9969 15.518C12.1199 15.518 12.2219 15.62 12.2219 15.743V17.333ZM15.0179 17.558C15.0179 17.558 15.0029 17.558 14.9969 17.558C14.8829 17.558 14.7839 17.471 14.7719 17.354L14.6279 15.764C14.6159 15.641 14.7089 15.53 14.8319 15.521C14.9579 15.509 15.0659 15.602 15.0749 15.725L15.2189 17.315C15.2309 17.438 15.1379 17.549 15.0149 17.558H15.0179ZM18.0389 17.558C18.0389 17.558 18.0119 17.561 17.9999 17.561C17.8919 17.561 17.7989 17.486 17.7779 17.375L17.4929 15.785C17.4719 15.662 17.5529 15.545 17.6759 15.524C17.7989 15.503 17.9159 15.584 17.9369 15.707L18.2219 17.297C18.2429 17.42 18.1619 17.537 18.0389 17.558ZM21.0569 17.555C21.0359 17.561 21.0179 17.564 20.9969 17.564C20.8979 17.564 20.8079 17.498 20.7809 17.399L20.3519 15.809C20.3189 15.689 20.3909 15.566 20.5109 15.533C20.6309 15.5 20.7539 15.572 20.7869 15.692L21.2159 17.282C21.2489 17.402 21.1769 17.525 21.0569 17.558V17.555Z"
                fill="url(#paint1_linear_1280_36307)"
            />
            <path d="M24 18.791H0V21.47H24V18.791Z" fill="url(#paint2_linear_1280_36307)" />
            <path
                d="M7.4043 7.23499H16.5963V3.66199C16.5963 3.09499 16.1373 2.63599 15.5703 2.63599H8.4303C7.8633 2.63599 7.4043 3.09499 7.4043 3.66199V7.23499Z"
                fill="url(#paint3_linear_1280_36307)"
            />
            <path
                d="M10.7583 9.53006H15.5703C16.1373 9.53006 16.5963 9.07106 16.5963 8.50406V7.68506H7.4043V8.50406C7.4043 9.07106 7.8633 9.53006 8.4303 9.53006H10.7583Z"
                fill="url(#paint4_linear_1280_36307)"
            />
            <path
                d="M3.00005 3.806C3.34633 3.806 3.62705 3.52528 3.62705 3.179C3.62705 2.83272 3.34633 2.552 3.00005 2.552C2.65376 2.552 2.37305 2.83272 2.37305 3.179C2.37305 3.52528 2.65376 3.806 3.00005 3.806Z"
                fill="url(#paint5_linear_1280_36307)"
            />
            <path
                d="M3.00005 7.45395C3.34633 7.45395 3.62705 7.17323 3.62705 6.82695C3.62705 6.48067 3.34633 6.19995 3.00005 6.19995C2.65376 6.19995 2.37305 6.48067 2.37305 6.82695C2.37305 7.17323 2.65376 7.45395 3.00005 7.45395Z"
                fill="url(#paint6_linear_1280_36307)"
            />
            <path
                d="M20.271 3.2061C20.271 3.5511 20.553 3.8331 20.898 3.8331C21.243 3.8331 21.525 3.5511 21.525 3.2061C21.525 2.8611 21.243 2.5791 20.898 2.5791C20.553 2.5791 20.271 2.8611 20.271 3.2061Z"
                fill="url(#paint7_linear_1280_36307)"
            />
            <path
                d="M20.271 6.85405C20.271 7.19905 20.553 7.48105 20.898 7.48105C21.243 7.48105 21.525 7.19905 21.525 6.85405C21.525 6.50905 21.243 6.22705 20.898 6.22705C20.553 6.22705 20.271 6.50905 20.271 6.85405Z"
                fill="url(#paint8_linear_1280_36307)"
            />
            <path
                d="M2.775 11.291H1.5V13.841H22.5V11.291H21.123V9.52703H22.194C22.722 9.52703 23.148 9.10103 23.148 8.57303V1.48403C23.148 0.956029 22.722 0.530029 22.194 0.530029H19.602C19.074 0.530029 18.648 0.956029 18.648 1.48403V8.57603C18.648 9.10403 19.074 9.53003 19.602 9.53003H20.673V11.294H3.225V9.53003H4.296C4.824 9.53003 5.25 9.10403 5.25 8.57603V1.48403C5.25 0.956029 4.824 0.530029 4.296 0.530029H1.704C1.176 0.530029 0.75 0.956029 0.75 1.48403V8.57603C0.75 9.10403 1.176 9.53003 1.704 9.53003H2.775V11.294V11.291ZM20.898 2.12903C21.492 2.12903 21.975 2.61203 21.975 3.20603C21.975 3.80003 21.492 4.28303 20.898 4.28303C20.304 4.28303 19.821 3.80003 19.821 3.20603C19.821 2.61203 20.304 2.12903 20.898 2.12903ZM19.821 6.85403C19.821 6.26003 20.304 5.77703 20.898 5.77703C21.492 5.77703 21.975 6.26003 21.975 6.85403C21.975 7.44803 21.492 7.93103 20.898 7.93103C20.304 7.93103 19.821 7.44803 19.821 6.85403ZM3 2.10203C3.594 2.10203 4.077 2.58503 4.077 3.17903C4.077 3.77303 3.594 4.25603 3 4.25603C2.406 4.25603 1.923 3.77303 1.923 3.17903C1.923 2.58503 2.406 2.10203 3 2.10203ZM1.923 6.82703C1.923 6.23303 2.406 5.75003 3 5.75003C3.594 5.75003 4.077 6.23303 4.077 6.82703C4.077 7.42103 3.594 7.90403 3 7.90403C2.406 7.90403 1.923 7.42103 1.923 6.82703Z"
                fill="url(#paint9_linear_1280_36307)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1280_36307"
                    x1="11.4762"
                    y1="9.98004"
                    x2="11.4762"
                    y2="11.1372"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1280_36307"
                    x1="6.99554"
                    y1="14.2913"
                    x2="6.99554"
                    y2="19.7154"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1280_36307"
                    x1="6.93229"
                    y1="18.7912"
                    x2="6.93229"
                    y2="22.3791"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_1280_36307"
                    x1="10.0594"
                    y1="2.63631"
                    x2="10.0594"
                    y2="8.79568"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_1280_36307"
                    x1="10.0594"
                    y1="7.68519"
                    x2="10.0594"
                    y2="10.1562"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_1280_36307"
                    x1="2.73526"
                    y1="2.55209"
                    x2="2.73526"
                    y2="4.23155"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_1280_36307"
                    x1="2.73526"
                    y1="6.20004"
                    x2="2.73526"
                    y2="7.8795"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_1280_36307"
                    x1="20.6332"
                    y1="2.57919"
                    x2="20.6332"
                    y2="4.25865"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_1280_36307"
                    x1="20.6332"
                    y1="6.22714"
                    x2="20.6332"
                    y2="7.9066"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <linearGradient
                    id="paint9_linear_1280_36307"
                    x1="7.21956"
                    y1="0.530958"
                    x2="7.21956"
                    y2="18.3582"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
            </defs>
        </SvgIcon>
    )
}
